module.exports = __webpack_public_path__ + "img/Group 2336.967b4202.png";